/* tslint:disable */
/* eslint-disable */
/**
 * Tanagra Service API
 * github.com/DataBiosphere/tanagra
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReviewUpdateInfo
 */
export interface ReviewUpdateInfo {
    /**
     * Human readable name of the review
     * @type {string}
     * @memberof ReviewUpdateInfo
     */
    displayName?: string;
    /**
     * Description of the review
     * @type {string}
     * @memberof ReviewUpdateInfo
     */
    description?: string;
}

/**
 * Check if a given object implements the ReviewUpdateInfo interface.
 */
export function instanceOfReviewUpdateInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReviewUpdateInfoFromJSON(json: any): ReviewUpdateInfo {
    return ReviewUpdateInfoFromJSONTyped(json, false);
}

export function ReviewUpdateInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewUpdateInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function ReviewUpdateInfoToJSON(value?: ReviewUpdateInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayName': value.displayName,
        'description': value.description,
    };
}

